import React from "react";
import { Button, Empty, Typography, ConfigProvider } from "antd";
import { useSelector } from "react-redux";
import { getTenantConfig } from "ee/selectors/tenantSelectors";
export interface EmptyComponentProps {
  image: string;
  description?: string;
  buttonText?: string;
  onClick?: () => void;
  imageStyle?: React.CSSProperties;
}

const EmptyComponent: React.FC<EmptyComponentProps> = ({
  image = {},
  description,
  buttonText,
  onClick,
  imageStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}) => {
  const tenantConfig = useSelector(getTenantConfig);
  const { brandColors } = tenantConfig;
  return (
    <ConfigProvider
      theme={{
        token: {
          colorTextDescription: "#000000e6",
          colorBgContainer: brandColors.primary,
        },
        components: {
          Button: {
            defaultBg: brandColors.primary,
            defaultColor: "#fff",
            defaultHoverColor: "#fff",
          },
        },
      }}
    >
      <Empty
        image={image}
        styles={{
          image: {
            ...imageStyle,
          },
        }}
        description={
          description && (
            <Typography.Text style={{ color: "#000000e6" }}>
              {description}
            </Typography.Text>
          )
        }
      >
        {buttonText && (
          <Button
            type="default"
            style={{
              borderRadius: "6px",
            }}
            onClick={onClick}
          >
            {buttonText}
          </Button>
        )}
      </Empty>
    </ConfigProvider>
  );
};

export default EmptyComponent;
